import { render, staticRenderFns } from "./newOrder.vue?vue&type=template&id=3a5dd826&scoped=true&"
import script from "./newOrder.vue?vue&type=script&lang=js&"
export * from "./newOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5dd826",
  null
  
)

component.options.__file = "src/demo/packageMall/newOrder.vue"
export default component.exports